import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import moment from "moment";
import 'moment/locale/tr';
moment.locale("tr");
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0] ? document.getElementsByTagName("base")[0].getAttribute("href") : "/";
const history = createBrowserHistory({ basename: baseUrl });
console.log(baseUrl);
// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;

export const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");

ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    ,
    rootElement);

registerServiceWorker();
